import React from "react";
import { Link } from "react-router-dom";
import { BRAND_OPERATOR_LINE, COMPANY } from "@/lib/companyInfo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted/50 border-t mt-16" role="contentinfo">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="font-semibold mb-4">About</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Statistical compatibility calculator using real US Census and demographic data to provide evidence-based dating probability insights.
            </p>
            <p className="text-xs text-muted-foreground">
              All statistics sourced from government and research institutions.
            </p>
            <Link to="/about" className="inline-block text-sm text-muted-foreground hover:text-primary transition-colors mt-2">
              Learn more about us &rarr;
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Calculators & Data</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">
                  Female Partner Calculator
                </Link>
              </li>
              <li>
                <Link to="/male-partner-calculator" className="text-muted-foreground hover:text-primary transition-colors">
                  Male Partner Calculator
                </Link>
              </li>
              <li>
                <Link to="/ideal-woman-calculator" className="text-muted-foreground hover:text-primary transition-colors">
                  Ideal Woman Calculator
                </Link>
              </li>
              <li>
                <Link to="/dating-standards-calculator" className="text-muted-foreground hover:text-primary transition-colors">
                  Dating Standards Calculator
                </Link>
              </li>
              <li>
                <Link to="/stats" className="text-muted-foreground hover:text-primary transition-colors">
                  US Dating Statistics
                </Link>
              </li>
              <li>
                <Link to="/states" className="text-muted-foreground hover:text-primary transition-colors">
                  Statistics by State
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/methodology" className="text-muted-foreground hover:text-primary transition-colors">
                  Statistical Methodology
                </Link>
              </li>
              <li>
                <Link to="/data-sources" className="text-muted-foreground hover:text-primary transition-colors">
                  Data Sources
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">
                  Frequently Asked Questions
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-muted-foreground hover:text-primary transition-colors">
                  Glossary of Terms
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-muted-foreground hover:text-primary transition-colors">
                  Site Map
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <span className="text-muted-foreground">
                  Statistical probabilities only
                </span>
              </li>
              <li>
                <span className="text-muted-foreground">
                  Not relationship advice
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © {currentYear} {COMPANY.legalName}. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            {BRAND_OPERATOR_LINE}
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Data sources include U.S. Census Bureau, CDC, and Pew Research Center.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;